import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import useTranslation from "../../hooks/useTranslation";
import { useState } from "react";
import cssVars from '../../styles/vars.module.scss'

const CompanyKeyRegister = ({ setCompanyRegisterFormType }) => {
    const { t } = useTranslation()
    const [formType, setFormType] = useState(0)

    return (
        <Box>
            <Grid sx={{ "& h6,span": { fontFamily: "inherit" } }}>
                <Grid item xs={12} textAlign="center" mt={3}>
                    <ApartmentOutlinedIcon sx={{ mb: 1, borderRadius: "64px", fontSize: "52px", color: cssVars.lightBlack, backgroundColor: cssVars.lightGray, fontWeight: "thin", p: 1.5 }} />
                    <Typography variant="h6" className="pro-acc-title">{t("you have a PRO account")}</Typography>
                </Grid>
                <Grid item xs={12}>
                    {formType === 0 ?
                        <>
                            <Button variant="contained" sx={{
                                height: "50px !important",
                                fontSize: "16px",
                                fontWeight: '500 !important',
                                mt: 2,
                                borderRadius: cssVars.buttonRadius,
                                backgroundColor: `${cssVars.primary} !important`,
                                color: `${cssVars.white} ! important`,
                                border: `1px solid ${cssVars.primary} !important`,
                                ':hover': {
                                    bgcolor: `${cssVars.hoverColor} !important `,
                                    borderColor: `${cssVars.hoverColor} !important`,
                                    color: `${cssVars.white} ! important`
                                },
                                textTransform: 'unset'
                            }} fullWidth onClick={() => setFormType(1)}>
                                {t("i have an identification key")}
                            </Button>
                            <Button variant="outlined" color="secondary" fullWidth
                                sx={{
                                    height: "50px !important",
                                    fontSize: "16px",
                                    fontWeight: '500 !important',
                                    mt: 2,
                                    borderRadius: cssVars.buttonRadius,
                                    backgroundColor: `${cssVars.white} !important`,
                                    color: `${cssVars.extraDarkGray} ! important`,
                                    border: `1px solid ${cssVars.darkGray} !important`,
                                    ':hover': {
                                        bgcolor: `${cssVars.hoverColor} !important `,
                                        borderColor: `${cssVars.hoverColor} !important`,
                                        color: `${cssVars.white} ! important`
                                    },
                                    textTransform: 'unset'
                                }} onClick={() => setFormType(2)}>
                                {t("i do not have an identification key")}
                            </Button>
                        </>
                        :
                        null
                    }
                    {formType === 1 ?
                        <Box component="form">
                            <TextField
                                sx={{ mt: 2, }}
                                label={<Box sx={{color:cssVars.extraDarkGray}}>{t("Identification key")}</Box>}
                                fullWidth variant="outlined" placeholder={t("Identification key")}
                            />
                            <Button type="submit" variant="contained" color="primary" fullWidth
                                sx={{
                                    height: "50px !important",
                                    fontSize: "16px",
                                    fontWeight: '400 !important',
                                    mt: "30px !important",
                                    borderRadius: cssVars.buttonRadius,
                                    backgroundColor: `${cssVars.primary} !important`,
                                    color: `${cssVars.white} ! important`,
                                    border: `1px solid ${cssVars.primary} !important`,
                                    ':hover': {
                                        bgcolor: `${cssVars.hoverColor} !important `,
                                        borderColor: `${cssVars.hoverColor} !important`,
                                        color: `${cssVars.white} ! important`
                                    },
                                    textTransform: 'unset'
                                }}>
                                {t("verify a key")}
                            </Button>
                            <Box display="flex" justifyContent="center">
                                <Button variant="outlined" fullWidth
                                    sx={{
                                        height: "50px !important",
                                        fontSize: "16px",
                                        fontWeight: '500 !important',
                                        mt: 2,
                                        borderRadius: cssVars.buttonRadius,
                                        backgroundColor: `${cssVars.white} !important`,
                                        color: `${cssVars.extraDarkGray} ! important`,
                                        border: `1px solid ${cssVars.darkGray} !important`,
                                        ':hover': {
                                            bgcolor: `${cssVars.hoverColor} !important `,
                                            borderColor: `${cssVars.hoverColor} !important`,
                                            color: `${cssVars.white} ! important`
                                        },
                                        textTransform: 'unset'
                                    }} onClick={() => setFormType(0)}>
                                    {t("Cancel")}
                                </Button>
                            </Box>
                        </Box>
                        :
                        null
                    }
                    {
                        formType === 2 ?
                            <>
                                <Box className='justify-content-center p-3 bg-light-gray extra-dark-gray text-center'>
                                    {t("contact with our sales staff")}
                                </Box>
                                <Button variant="outlined" fullWidth
                                    sx={{
                                        height: "50px !important",
                                        fontSize: "16px",
                                        fontWeight: '500 !important',
                                        mt: 2,
                                        borderRadius: cssVars.buttonRadius,
                                        backgroundColor: `${cssVars.white} !important`,
                                        color: `${cssVars.extraDarkGray} ! important`,
                                        border: `1px solid ${cssVars.darkGray} !important`,
                                        ':hover': {
                                            bgcolor: `${cssVars.hoverColor} !important `,
                                            borderColor: `${cssVars.hoverColor} !important`,
                                            color: `${cssVars.white} ! important`
                                        },
                                        textTransform: 'unset'
                                    }} onClick={() => setFormType(0)}>
                                    {t("Cancel")}
                                </Button>
                            </>
                            :
                            null
                    }
                </Grid>
            </Grid>
            <hr />
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} textAlign="center" pt={4} mt={3}>
                    <PersonOutlinedIcon sx={{ mb: 1, borderRadius: "64px", fontSize: "52px", color: cssVars.lightBlack, backgroundColor: cssVars.lightGray, fontWeight: "thin", p: 1.5 }} />
                    <Typography variant="h6" sx={{ fontSize: 16, fontFamily: "inherit" }}>{t("you don't have a PRO account")}</Typography>
                </Grid>
                <Grid item xs={12} textAlign="center">
                    <Button variant="contained" color="primary" fullWidth sx={{
                        height: "50px !important",
                        fontSize: "16px",
                        fontWeight: '500 !important',
                        borderRadius: cssVars.buttonRadius,
                        backgroundColor: `${cssVars.primary} !important`,
                        color: `${cssVars.white} ! important`,
                        border: `1px solid ${cssVars.primary} !important`,
                        ':hover': {
                            bgcolor: `${cssVars.hoverColor} !important `,
                            borderColor: `${cssVars.hoverColor} !important`,
                            color: `${cssVars.white} ! important`
                        },
                        textTransform: 'unset'
                    }}
                        onClick={() => setCompanyRegisterFormType(1)}
                    >
                        {t("Create an access")}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default CompanyKeyRegister;